module.exports = __webpack_public_path__ + "img/UK.dcf6bf59.webp";